import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';

@Injectable()
export class AttachmentService extends BaseService {

  getFile(path, options) {
    return this.http.get(path, options);
  }
  getAttachment(path: String) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      path
    };

    return this.http.post(this.url + 'api/upload/getAttachment', body, { headers: headers });
  }

  deleteFile(path: string, pkey) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      path,
      pkey
    };

    return this.http.post(this.url + 'api/upload/deleteFile', body, { headers: headers });
  }

  restore(path: string, pkey) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      path,
      pkey
    };

    return this.http.post(this.url + 'api/upload/restore', body, { headers: headers });
  }

  deleteForEver(path: string, pkey) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      path,
      pkey
    };

    return this.http.post(this.url + 'api/upload/deleteforever', body, { headers: headers });
  }

}
